export default "__VITE_ASSET__DfrqbMTK__"